import React from 'react';
import { Row, RowProps } from '../Row/Row';

/* Types */
export interface SearchBoxProps extends RowProps {
  backgroundColor?: string;
  clearButton?: {
    hideWhenValueEmpty: boolean;
    on: boolean;
  };
  disableEnterSubmit?: boolean;
  handleInputChange: (newText: string) => void;
  icon?: {
    active: boolean;
    node: React.ReactNode;
    onClick?: () => void;
    position: 'left' | 'right';
  };
  inputStyle?: React.HTMLProps<HTMLInputElement>['style'];
  placeholder?: string;
  size: {
    height: { maxHeight: string } | string;
    maxHeight?: string;
    maxWidth?: string;
    width: { maxWidth: string } | string;
  };
  value: string;
}

/* Components */
const SearchBoxClearButton = ({ handleInputChange }) => (
  <button
    className="icb"
    onClick={() => {
      handleInputChange('');
    }}
    style={{ cursor: 'pointer', fontSize: '13px' }}
    type="button"
  >
    ✕
  </button>
);

const SearchBoxInput = ({ handleInputChange, inputStyle, placeholder, onKeyPress, value }) => (
  <div className="icb" style={{ flex: 1, height: '100%', position: 'relative' }}>
    <input
      className="icb"
      onChange={({ target: { value: newValue } }: React.ChangeEvent<HTMLInputElement>) => {
        handleInputChange(newValue);
      }}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
      style={{
        ...inputStyle,
        backgroundColor: 'transparent',
        height: '100%',
        outlineWidth: 0,
        position: 'absolute',
        width: '100%',
      }}
      type="search"
      value={value}
    />
  </div>
);

export const SearchBox: React.FC<SearchBoxProps> = React.memo(props => {
  const {
    clearButton,
    disableEnterSubmit,
    icon,
    inputStyle,
    handleInputChange,
    value,
    placeholder,
    size: { width, height },
    ...restProps
  } = props;

  return (
    <Row
      alignItems="center"
      flexDirection={icon && icon.position === 'right' ? 'row-reverse' : undefined}
      height={typeof height === 'object' ? '100%' : height}
      maxHeight={typeof height === 'object' ? height.maxHeight : undefined}
      maxWidth={typeof width === 'object' ? width.maxWidth : undefined}
      width={typeof width === 'object' ? '100%' : width}
      {...restProps}
    >
      {icon && icon.node}
      <SearchBoxInput
        handleInputChange={handleInputChange}
        inputStyle={inputStyle}
        onKeyPress={
          disableEnterSubmit
            ? e => {
                e.key === 'Enter' && e.preventDefault();
              }
            : undefined
        }
        placeholder={placeholder}
        value={value}
      />
      {clearButton.on && (!clearButton.hideWhenValueEmpty || value) && (
        <SearchBoxClearButton handleInputChange={handleInputChange} />
      )}
    </Row>
  );
});
